import { Target, Heart, Shield, Sparkles } from "lucide-react";

const values = [
  {
    icon: Target,
    title: "Precisione",
    description: "Ogni installazione è eseguita con la massima cura e attenzione ai dettagli.",
    color: "#FF3B30"
  },
  {
    icon: Heart,
    title: "Passione",
    description: "Amiamo il nostro lavoro e trasmettiamo questa passione in ogni progetto.",
    color: "#FF9500"
  },
  {
    icon: Shield,
    title: "Sicurezza",
    description: "Serramenti certificati che proteggono la tua casa e la tua famiglia.",
    color: "#4CD964"
  },
  {
    icon: Sparkles,
    title: "Qualità",
    description: "Materiali premium e finiture impeccabili per risultati duraturi.",
    color: "#007AFF"
  }
];

export default function MissionSection() {
  return (
    <section id="missione" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16 md:mb-20">
          <p className="text-sm font-bold uppercase tracking-[0.2em] bg-clip-text text-transparent bg-gradient-to-r from-orange-500 via-blue-500 to-purple-500 mb-4">
            La Nostra Missione
          </p>
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-[#0B1E36] mb-6">
            Qualità, Design e Passione per la Tua Casa
          </h2>
          <p className="text-base md:text-lg text-[#64748B] leading-relaxed">
            In Finestre e Colore, crediamo che ogni casa meriti il meglio. La nostra missione è 
            fornire serramenti che combinano estetica, funzionalità e risparmio energetico, 
            trasformando ogni spazio in un ambiente più luminoso, sicuro e confortevole.
          </p>
        </div>

        {/* Values Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {values.map((value, index) => (
            <div 
              key={value.title}
              className="service-card bg-[#FAFAFA] rounded-3xl p-8 text-center"
              style={{ animationDelay: `${index * 100}ms` }}
              data-testid={`value-card-${value.title.toLowerCase()}`}
            >
              <div 
                className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-6"
                style={{ backgroundColor: `${value.color}15` }}
              >
                <value.icon className="w-8 h-8" style={{ color: value.color }} />
              </div>
              <h3 className="text-xl font-bold text-[#0B1E36] mb-3">{value.title}</h3>
              <p className="text-[#64748B] leading-relaxed">{value.description}</p>
            </div>
          ))}
        </div>

        {/* Mission Statement Box */}
        <div className="mt-16 md:mt-20 bg-gradient-to-r from-[#0B1E36] to-[#1a3a5c] rounded-3xl p-8 md:p-12 text-center text-white">
          <blockquote className="text-xl md:text-2xl font-medium italic leading-relaxed max-w-4xl mx-auto">
            "Il nostro obiettivo è rendere ogni casa più bella, efficiente e sicura. 
            Ogni finestra che installiamo è una promessa di qualità e professionalità 
            che manteniamo da sempre."
          </blockquote>
          <p className="mt-6 text-white/70 font-medium">
            — Il Team di Finestre e Colore
          </p>
        </div>
      </div>
    </section>
  );
}
